/* tslint:disable */
/* eslint-disable */
/**
 * Yaway Workshop API
 * Yaway Workshop API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApiOtherPartiesSection
 */
export interface ApiOtherPartiesSection {
    /**
     * 
     * @type {string}
     * @memberof ApiOtherPartiesSection
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiOtherPartiesSection
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiOtherPartiesSection
     */
    personalCode?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiOtherPartiesSection
     */
    phoneNumberPrefix?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiOtherPartiesSection
     */
    phoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiOtherPartiesSection
     */
    email?: string;
}

export function ApiOtherPartiesSectionFromJSON(json: any): ApiOtherPartiesSection {
    return ApiOtherPartiesSectionFromJSONTyped(json, false);
}

export function ApiOtherPartiesSectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiOtherPartiesSection {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'description': !exists(json, 'description') ? undefined : json['description'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'personalCode': !exists(json, 'personalCode') ? undefined : json['personalCode'],
        'phoneNumberPrefix': !exists(json, 'phoneNumberPrefix') ? undefined : json['phoneNumberPrefix'],
        'phoneNumber': !exists(json, 'phoneNumber') ? undefined : json['phoneNumber'],
        'email': !exists(json, 'email') ? undefined : json['email'],
    };
}

export function ApiOtherPartiesSectionToJSON(value?: ApiOtherPartiesSection | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'description': value.description,
        'name': value.name,
        'personalCode': value.personalCode,
        'phoneNumberPrefix': value.phoneNumberPrefix,
        'phoneNumber': value.phoneNumber,
        'email': value.email,
    };
}

